import { Tooltip } from "antd";
import React from "react";

export default function TooltipComp({
  children,
  title,
  getPopupContainer,
  overlayStyle,
  ...rest
}) {
  return (
    <Tooltip
      placement="top"
      color={"#fff"}
      overlayInnerStyle={{
        color: "#5C667B",
        fontSize: "14px",
        textAlign: "center",
        maxWidth: "400px", // Ensures the tooltip doesn’t expand too much
        fontWeight:'normal'
      }}
      overlayStyle={{
        textAlign: "center",
        maxWidth: "400px", // Ensures the tooltip is properly constrained
        ...(overlayStyle || {}),
      }}
      title={title}
      getPopupContainer={getPopupContainer || ((trigger) => trigger.parentNode)}
      {...rest}
    >
      {children}
    </Tooltip>
  );
}
